import { useState } from "react";
import axios from "axios";
import { IceCreamCone, ArrowLeft } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const [key, setKey] = useState("");
  const [items, setItems] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const load = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(`${API}/enquiries`, { headers: { "X-Admin-Key": key } });
      setItems(res.data);
    } catch {
      setError("Wrong key — no sprinkles for you.");
      setItems(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-page" className="min-h-screen bg-[#2D1A13] text-[#FDFBF7] px-6 py-12">
      <div className="max-w-3xl mx-auto">
        <a data-testid="admin-back-link" href="/" className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] text-[#FDFBF7]/60 hover:text-[#FF8E9E] transition-colors mb-12">
          <ArrowLeft size={14} /> Back to site
        </a>
        <h1 className="font-serif-display font-bold tracking-tighter text-4xl md:text-5xl flex items-center gap-4">
          <IceCreamCone size={36} strokeWidth={1.4} className="text-[#FF8E9E]" />
          Studio Enquiries
        </h1>

        {items === null && (
          <form data-testid="admin-key-form" onSubmit={load} className="mt-12 flex flex-col sm:flex-row gap-4">
            <input
              data-testid="admin-key-input"
              type="password"
              value={key}
              onChange={(e) => setKey(e.target.value)}
              placeholder="Admin key"
              className="flex-1 bg-transparent border-b border-[#FDFBF7]/25 focus:border-[#FF8E9E] outline-none py-4 text-xl font-light placeholder:text-[#FDFBF7]/30 transition-colors"
            />
            <button
              data-testid="admin-key-submit"
              type="submit"
              disabled={loading}
              className="rounded-full bg-[#FF8E9E] text-[#2D1A13] text-xs font-bold uppercase tracking-[0.2em] px-8 py-4 hover:bg-[#FDFBF7] transition-colors disabled:opacity-60"
            >
              {loading ? "Checking…" : "Unlock"}
            </button>
          </form>
        )}
        {error && <p data-testid="admin-error" className="mt-6 text-[#FF8E9E] text-sm">{error}</p>}

        {items !== null && (
          <div className="mt-12">
            <p data-testid="admin-count" className="text-[11px] uppercase tracking-[0.25em] text-[#FDFBF7]/50 mb-8 font-semibold">
              {items.length} enquir{items.length === 1 ? "y" : "ies"}
            </p>
            {items.length === 0 && (
              <p data-testid="admin-empty" className="text-[#FDFBF7]/60 font-light">Nothing in the freezer yet.</p>
            )}
            <div className="flex flex-col gap-6">
              {items.map((it) => (
                <div data-testid={`admin-enquiry-${it.id}`} key={it.id} className="rounded-2xl border border-[#FDFBF7]/15 p-7">
                  <div className="flex flex-wrap items-baseline justify-between gap-2 mb-3">
                    <h3 className="font-serif-display font-bold text-2xl">{it.name}</h3>
                    <span className="text-[11px] text-[#FDFBF7]/45">{new Date(it.created_at).toLocaleString()}</span>
                  </div>
                  <p className="text-sm text-[#FF8E9E] mb-1">{it.email}</p>
                  {it.project_type && (
                    <p className="text-[11px] uppercase tracking-[0.2em] text-[#FDFBF7]/50 mb-3">{it.project_type}</p>
                  )}
                  <p className="text-sm font-light leading-relaxed text-[#FDFBF7]/80 whitespace-pre-wrap">{it.message}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
